function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M32.05,56.22a24.31,24.31,0,0,1-7.28-1.12v4.16a28.16,28.16,0,0,0,7.28,1,28.5,28.5,0,0,0,7.08-.9V55.16A24.36,24.36,0,0,1,32.05,56.22Zm-24-24a23.84,23.84,0,0,1,5.8-15.62V11A28,28,0,0,0,17.31,56V51.14A23.91,23.91,0,0,1,8.05,32.22Zm24-28a30.76,30.76,0,0,0-3.86.26,4.22,4.22,0,0,1,0,.52V8.52a24,24,0,0,1,3.82-.3,26.46,26.46,0,0,1,3.58.26V6.78A7.08,7.08,0,0,1,36,4.5,28.84,28.84,0,0,0,32.05,4.22Zm14.58,4.1v4.86a24,24,0,0,1,0,38.08v4.86a28,28,0,0,0,0-47.8Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M44.63,4.64V60.32a2,2,0,0,1-1.76,2.16,2,2,0,0,1-1.74-2.16V34.64a2,2,0,0,0-1.76-2.16,2,2,0,0,1-1.74-2.16V6.78A4.57,4.57,0,0,1,38,4.86a3.46,3.46,0,0,1,3.12-2.38h1.74A2,2,0,0,1,44.63,4.64Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M26.23,5V22.6a2,2,0,0,1-1.74,2.12,2,2,0,0,0-1.72,2.12V60a2,2,0,0,1-1.72,2.12A2,2,0,0,1,19.31,60V26.84a2,2,0,0,0-1.72-2.12,2,2,0,0,1-1.74-2.12V5a2,2,0,0,1,1.74-2.12h.62V19.62a.83.83,0,0,0,1.66,0V2.88h2.36V19.62a.83.83,0,0,0,.84.82.81.81,0,0,0,.82-.82V2.88h.6a1.9,1.9,0,0,1,1.72,1.94A.55.55,0,0,1,26.23,5Z"
});

var SvgMealPlan = function SvgMealPlan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMealPlan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MealPlan.ac9e905a.svg";
export { ForwardRef as ReactComponent };